import { ReactNode } from "react";

// Stub license provider for dashboard - position apps handle their own licenses
export const LicenseProvider = ({ children }: { children: ReactNode }) => {
  return <>{children}</>;
};
